export { default as LoginFormStyle } from './LoginForm.module.scss';
